import React from "react";
import "./index.css";
import Intro from './intro';
import Temario from './temario';
import Calendario from './calendario';
import Social from './social';

export default function RicoData() {
  return (
    <div id="ricoendata">
      <Intro />
      <Temario />
      <Calendario />
      <Social />
    </div>
  );
}
